module.exports = __webpack_public_path__ + "img/Vector6.cd09e260.svg";